import styles from "./css/Spinner.module.css";

interface SpinnerProps {
  size?: number;
  label?: string;
}

export default function Spinner({ size = 24, label }: SpinnerProps) {
  return (
    <span
      className={styles.spinner}
      style={{ width: size, height: size }}
      role={label ? "status" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    />
  );
}
